// Actions partagees sur une piece PDF (Sprint 2 §14).
//
// Le bouton corbeille apparait dans plusieurs listes (panneau viewer, onglet
// Pieces, vue auto Inventaire, resultats Recherche). Cette factorisation
// garantit que tous utilisent la meme confirmation et le meme code-erreur
// pour ne pas se desynchroniser.
import { ApiError, api } from './api';
import { toast } from '../stores/toaster';

/**
 * Demande confirmation puis appelle DELETE /pdfs/{id}.
 *
 * Retourne `true` si l'utilisateur a confirme ET la suppression a reussi
 * cote serveur ; `false` sinon (annulation ou erreur). En cas d'erreur,
 * un toast est deja affiche, l'appelant n'a rien a faire.
 *
 * Le serveur cascade les annotations/notes/bookmarks/inventaire-link/OCR
 * via FK ON DELETE CASCADE. Voir backend/app/pdfs/service.py:delete_pdf.
 */
export async function confirmAndDeletePdf(pdfId: string, displayName: string): Promise<boolean> {
  const ok = window.confirm(
    `Supprimer definitivement la piece « ${displayName} » ?\n\n` +
      'Toutes les annotations, notes et marqueurs lies seront effaces.'
  );
  if (!ok) return false;
  try {
    await api.delete(`/pdfs/${pdfId}`);
    toast.success('Piece supprimee');
    return true;
  } catch (err) {
    toast.error(
      err instanceof ApiError ? (err.problem.detail ?? err.problem.title) : 'Erreur reseau'
    );
    return false;
  }
}
